
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "app-modal",
})
export default class extends Vue {}
